import ACTION_TYPES from '../../constants/actionTypes';

const reducers = {

  baggageLocation(state = {}, action) {
    switch (action.type) {
      case ACTION_TYPES.SAVE_BAGGAGE_LOCATION:
        return action.locationInfo;
      case ACTION_TYPES.SIGN_OUT:
        return {};
      default:
        return state;
    }
  },

  baggageAirline(state = null, action) {
    switch (action.type) {
      case ACTION_TYPES.SAVE_BAGGAGE_AIRLINE:
        return action.fsCode;
      case ACTION_TYPES.SAVE_BAGGAGE_LOCATION:
      case ACTION_TYPES.SIGN_OUT:
        return null;
      default:
        return state;
    }
  },

  baggageConfirmationNumber(state = '', action) {
    switch (action.type) {
      case ACTION_TYPES.SAVE_BAGGAGE_CONFIRMATION_NUMBER:
        return action.confirmationNumber;
      case ACTION_TYPES.SAVE_BAGGAGE_LOCATION:
      case ACTION_TYPES.SIGN_OUT:
        return '';
      default:
        return state;
    }
  },

  baggagePassengerInfo(state = {}, action) {
    switch (action.type) {
      case ACTION_TYPES.SAVE_BAGGAGE_PASSENGER_INFO:
        return Object.assign({}, state, action.payload);
      case ACTION_TYPES.SAVE_BAGGAGE_LOCATION:
      case ACTION_TYPES.SIGN_OUT:
        return {};
      default:
        return state;
    }
  },

  isBaggageInProgress(state = false, action) {
    switch (action.type) {
      case ACTION_TYPES.GET_BAGGAGE_PLANS:
      case ACTION_TYPES.CHECKOUT_BAGGAGE:
      case ACTION_TYPES.PURCHASE_BAGGAGE:
        return true;
      case ACTION_TYPES.GET_BAGGAGE_PLANS_SUCCESS:
      case ACTION_TYPES.GET_BAGGAGE_PLANS_FAILURE:
      case ACTION_TYPES.CHECKOUT_BAGGAGE_SUCCESS:
      case ACTION_TYPES.CHECKOUT_BAGGAGE_FAILURE:
      case ACTION_TYPES.PURCHASE_BAGGAGE_SUCCESS:
      case ACTION_TYPES.PURCHASE_BAGGAGE_FAILURE:
        return false;
      default:
        return state;
    }
  },

  baggagePlans(state = [], action) {
    switch (action.type) {
      case ACTION_TYPES.GET_BAGGAGE_PLANS_SUCCESS:
        return action.data.plans;
      case ACTION_TYPES.SAVE_BAGGAGE_LOCATION:
      case ACTION_TYPES.SIGN_OUT:
        return [];
      default:
        return state;
    }
  },

  baggageSettings(state = {}, action) {
    switch (action.type) {
      case ACTION_TYPES.GET_BAGGAGE_PLANS_SUCCESS:
        return action.data.settings;
      case ACTION_TYPES.SAVE_BAGGAGE_LOCATION:
      case ACTION_TYPES.SIGN_OUT:
        return {};
      default:
        return state;
    }
  },

  baggageSelectedPlanId(state = null, action) {
    switch (action.type) {
      case ACTION_TYPES.SELECT_BAGGAGE_PLAN:
        return action.payload.planId;
      case ACTION_TYPES.SAVE_BAGGAGE_LOCATION:
      case ACTION_TYPES.SIGN_OUT:
        return null;
      default:
        return state;
    }
  },

  baggageCheckout(state = {}, action) {
    switch (action.type) {
      case ACTION_TYPES.CHECKOUT_BAGGAGE_SUCCESS:
        return action.data;
      case ACTION_TYPES.SAVE_BAGGAGE_LOCATION:
      case ACTION_TYPES.SIGN_OUT:
        return {};
      default:
        return state;
    }
  },

  baggagePurchase(state = {}, action) {
    switch (action.type) {
      case ACTION_TYPES.PURCHASE_BAGGAGE_SUCCESS:
        return action.data;
      case ACTION_TYPES.PURCHASE_BAGGAGE:
      case ACTION_TYPES.PURCHASE_BAGGAGE_FAILURE:
      case ACTION_TYPES.SAVE_BAGGAGE_LOCATION:
      case ACTION_TYPES.SIGN_OUT:
        return {};
      default:
        return state;
    }
  },

};

export default reducers;
